<template>
  <VContainer fluid>
    <router-view />
  </VContainer>
</template>

<script>
export default {
  name: 'History',
  data() {
    return {};
  },
};
</script>

<style scoped>
.history_container {
  height: calc(100vh - 130px);
  overflow-y: auto;
}
</style>
